<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('withdraw.with_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />

        <div v-else class="record-list">
          <div class="record-card" v-for="(v, key) in list" :key="key">
            <div class="record-top">
              <div class="status" :class="statusClass(v.status)">
                {{ v.status_text }}
              </div>
              <div class="money" :class="{ income: isRefundStatus(v.status) }">
                {{ amountPrefix(v.status) }}{{ v.money }}
              </div>
            </div>

            <div class="meta-row">
              <span class="meta-label">{{ $t("withdraw.type") }}</span>
              <span class="meta-value">{{ v.pay_type_name && (v.pay_type_name.includes('虚拟') || v.pay_type_name.includes('USDT') || v.pay_type === 2 || v.pay_type === '2' || v.pay_type === 'virtual' || v.pay_type === 'usdt') ? ($t('my.withdraw2') === 'USDT Withdrawal' ? 'USDT Withdrawal' : $t('my.withdraw2').replace('提现', '')) : ($t('my.withdraw1') === 'Bank Account Withdrawal' ? 'BANK Account' : $t('my.withdraw1').replace('提现', '')) }}</span>
            </div>
            <div class="meta-row">
              <span class="meta-label">{{ $t("withdraw.submit_time") }}</span>
              <span class="meta-value">{{ v.create_time }}</span>
            </div>
            <div class="meta-row">
              <span class="meta-label">{{ $t("withdraw.check_time") }}</span>
              <span class="meta-value">{{ v.update_time }}</span>
            </div>
            <div v-if="showRejectReason(v)" class="reject-card">
              <div class="reject-label">{{ $t("withdraw.reject_reason") }}</div>
              <div class="reject-value">{{ v.desc }}</div>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      this.getUserWithdrawList().finally(() => {
        setTimeout(() => {
          this.$toast(this.$t("reservation.refresh"));
          this.isLoading = false;
        }, 300);
      });
    },
    getUserWithdrawList() {
      return this.$http({
        method: "get",
        url: "user_get_withdraw_list",
      }).then((res) => {
        if (res.code === 200) {
          console.log("获取信息", res.data);
          console.log("退回信息", res.data[0].desc);
          this.list = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    statusClass(status) {
      if (status === 2 || status === 4) {
        return "success";
      }
      if (status === 3) {
        return "warning";
      }
      return "default";
    },
    isRefundStatus(status) {
      return Number(status) === 3;
    },
    amountPrefix(status) {
      return this.isRefundStatus(status) ? "+" : "-";
    },
    showRejectReason(item) {
      return Number(item.status) === 3 && !!String(item.desc || "").trim();
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: linear-gradient(#1a1a1a, #000000) !important;
}

.content {
  padding: 16px;
  min-height: calc(100% - 46px);
}

.record-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.record-card {
  padding: 16px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.record-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 22px;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.status.success {
  color: #6fe3a1;
  background: rgba(37, 197, 94, 0.14);
}

.status.warning {
  color: #ffbe5c;
  background: rgba(255, 190, 92, 0.14);
}

.money {
  color: #ff6d7a;
  font-size: 34px;
  font-weight: 700;
}

.money.income {
  color: #6fe3a1;
}

.meta-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}

.meta-label {
  color: #8f93a1;
  font-size: 22px;
}

.meta-value {
  color: #fff;
  font-size: 24px;
  text-align: right;
  word-break: break-word;
}

.reject-card {
  margin-top: 10px;
  padding: 12px;
  border-radius: 14px;
  background: rgba(255, 107, 107, 0.08);
  border: 1px solid rgba(255, 107, 107, 0.16);
}

.reject-label {
  color: #ff9da6;
  font-size: 22px;
  margin-bottom: 6px;
}

.reject-value {
  color: #fff;
  font-size: 24px;
  line-height: 1.6;
  word-break: break-word;
}

::v-deep .van-empty__description {
  color: #8f93a1;
}
</style>
